/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Splits_Edit_TitleInputs */

const cs_deal_splits_edit_title = /** @type {(inputs: Deal_Splits_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravit podíl na provizi`)
};

const en_deal_splits_edit_title = /** @type {(inputs: Deal_Splits_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit provision split`)
};

/**
* | output |
* | --- |
* | "Edit provision split" |
*
* @param {Deal_Splits_Edit_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_splits_edit_title = /** @type {((inputs?: Deal_Splits_Edit_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Splits_Edit_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_splits_edit_title(inputs)
	return cs_deal_splits_edit_title(inputs)
});